import createAction from './';

export const SET_SELECTED_APPOINTMENT_ID = createAction('SET_SELECTED_APPOINTMENT_ID');

export const setSelectedAppointmentId = (appointmentId) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_APPOINTMENT_ID,
    payload: { appointmentId },
  });
};
